export const MAP_LANDMARKS_DELETE_OPEN_MODAL = "MAP_LANDMARKS_DELETE_OPEN_MODAL";

export const MAP_LANDMARKS_DELETE_LANDMARKS = "MAP_LANDMARKS_DELETE_LANDMARKS";
export const MAP_LANDMARKS_DELETE_LANDMARKS_RESPONSE = "MAP_LANDMARKS_DELETE_LANDMARKS_RESPONSE";